import React from 'react';
import { Check } from 'lucide-react';

/**
 * Indicador de progreso para formularios multi-paso
 */
const StepIndicator = ({ currentStep, totalSteps, steps }) => {
    return (
        <div className="w-full mb-8">
            {/* Progress bar */}
            <div className="relative">
                <div className="flex justify-between mb-2">
                    {steps.map((step, index) => (
                        <div key={index} className="flex-1 text-center">
                            <div className="relative">
                                {/* Línea de conexión */}
                                {index < steps.length - 1 && (
                                    <div
                                        className={`absolute top-5 left-1/2 w-full h-0.5 -z-10
                      ${index < currentStep - 1 ? 'bg-blue-600' : 'bg-gray-300'}`}
                                    />
                                )}

                                {/* Círculo del paso */}
                                <div className="flex justify-center">
                                    <div
                                        className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold
                      transition-all duration-200
                      ${index < currentStep - 1
                                                ? 'bg-blue-600 text-white'
                                                : index === currentStep - 1
                                                    ? 'bg-blue-600 text-white ring-4 ring-blue-200'
                                                    : 'bg-gray-300 text-gray-600'
                                            }`}
                                    >
                                        {index < currentStep - 1 ? (
                                            <Check size={20} />
                                        ) : (
                                            <span>{index + 1}</span>
                                        )}
                                    </div>
                                </div>

                                {/* Etiqueta del paso */}
                                <div className="mt-2">
                                    <p className={`text-xs font-medium
                    ${index === currentStep - 1 ? 'text-blue-600' : 'text-gray-600'}`}
                                    >
                                        {step}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StepIndicator;
